import Api from '@/services';
import cookies from 'js-cookie';
import btnConfig from '@/utils/btn-config';
const user = {
    state: {
        userName: '',
        roles: [],
        loginStatus: false,
        groupType: null,
        btnCode: {},
        useInfo: {}
    },

    mutations: {
        SET_USER_INFO: (state, data) => {
            console.log('data', data);
            if (data) {
                state.roles = data.roleList;
                state.useInfo = data.useInfo;
                state.userName = data.useInfo.userName;
                state.loginStatus = false;
                state.btnCode = data.btnCode;
            } else {
                state.roles = [];
                state.useInfo = {};
                state.userName = '';
                state.loginStatus = true;
                state.btnCode = {};
            }

        },
    },

    actions: {
        // 获取用户信息
        GetInfo({ commit, dispatch }) {
            return new Promise(async (resolve, reject) => {
                try {
                    const response = await Api.queryResource();
                    if (!response.success) {
                        commit('SET_USER_INFO');
                        reject(response);
                    } else {
                        let { data } = response;
                        const btnCode = {}; // 按钮权限
                        // 页面权限
                        data.roleList = data.permissionList.map((item) => {
                            return item.code;
                        })
                        //按钮权限
                        // (data.buttonList || []).forEach( (item) => {
                        //     btnConfig.forEach( (btnItem) => {
                        //         if (item.code == btnItem.code) {
                        //             btnCode[btnItem.key] = true;
                        //         }
                        //     })
                        // })
                        data.btnCode = btnCode; // 按钮权限
                        data.useInfo = data.sysUser; //用户信息
                        localStorage.setItem('btnCode', JSON.stringify(btnCode));
                        localStorage.setItem('userInfo', JSON.stringify(data.useInfo));
                        commit('SET_USER_INFO', data);
                        resolve(data);
                    }
                } catch (error) {
                    commit('SET_USER_INFO');
                    reject(error);
                }
            });
        },

        // 前端 登出
        LogOut({ commit }) {
            return new Promise(async (resolve, reject) => {
                try {
                   const response = await Api.logout()
                    if (response.success) {
                        commit('SET_USER_INFO');
                        resolve();
                    } else {
                        reject(error);
                    }
                } catch (error) {
                    console.error(error)
                    reject(error);
                }
            });
        },
        // login
        Login({ commit, dispatch }, data) {
            return new Promise(async (resolve, reject) => {
                try {
                    const response = await Api.login(data)
                    if (response.success) {
                        localStorage.setItem('token', response.data.token);
                        const res = dispatch('GetInfo')
                        resolve(res);
                    } else {
                        reject(response);
                    }
                } catch (error) {
                    reject(error);
                }
            });
        },
    }

};

export default user;



// WEBPACK FOOTER //
// ./src/store/modules/user.js